export const checksumAddress = (address: string): string => address.toLowerCase();
